import React, { createContext, useState, useEffect } from 'react';
import api from '../utils/api';

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState({
        empresa_nombre: 'CRM',
        empresa_logo: null,
        color_primario: '#0057B7',
        color_secundario: '#00A651',
        color_fondo: '#F5F5F5'
    });

    useEffect(() => {
        const loadTheme = async () => {
            try {
                const { data } = await api.get('/settings/public');
                setTheme(data);
                // Aplicar colores CSS
                document.documentElement.style.setProperty('--color-primary', data.color_primario);
                document.documentElement.style.setProperty('--color-secondary', data.color_secundario);
                document.documentElement.style.setProperty('--color-fondo', data.color_fondo);
            } catch {
                // Usar valores por defecto
            }
        };
        loadTheme();
    }, []);

    return (
        <ThemeContext.Provider value={{ theme, setTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};
